import { useMemo } from 'react';
import { GenericDataTable, type GenericDataTableProps, type TableRow } from '@konnecta/generic-table';
import { useTableEmptyState } from '@hooks/useTableEmptyState';

/**
 * GenericDataTable with translated empty-state text. Anything the call site sets
 * itself, as the `emptyState` prop or in `config.emptyState`, still wins.
 */
export const AppDataTable = <TApi, TRow extends TableRow>({
  config,
  emptyState,
  ...rest
}: GenericDataTableProps<TApi, TRow>) => {
  const defaults = useTableEmptyState<TRow>();
  const ownEmptyState = emptyState ?? config.emptyState;
  // A fresh object every render would defeat the table's own memoization.
  const merged = useMemo(() => ({ ...defaults, ...ownEmptyState }), [defaults, ownEmptyState]);

  return <GenericDataTable<TApi, TRow> config={config} emptyState={merged} {...rest} />;
};
